import { z } from "zod";

/**
 * Editable homepage content, persisted in the `homepage` settings category.
 * Shared by the admin editor (write), the PUT validator (API), and the public
 * /api/homepage route (read) so the wire contract lives in exactly one place.
 */
export const HitRefSchema = z.object({
  type: z.enum(["trip", "activity"]),
  id: z.string(),
});
export type HitRef = z.infer<typeof HitRefSchema>;

export const DestRefSchema = z.object({
  id: z.string(),
  size: z.enum(["large", "small"]).optional(),
});
export type DestRef = z.infer<typeof DestRefSchema>;

export const HomepageSettingsSchema = z.object({
  heroTitle: z.string().max(200),
  heroSubtitle: z.string().max(300),
  heroBackgroundImageId: z.string().nullable(),
  monthlyHits: z.array(HitRefSchema),
  popularDestinations: z.array(DestRefSchema),
});
export type HomepageSettings = z.infer<typeof HomepageSettingsSchema>;
